let sidePanelInvoiceablesSelector = $('[id^="data-side-panel-invoiceable-selector"]');

if (sidePanelInvoiceablesSelector.length) {
    sidePanelInvoiceablesSelector
        .bind('nc.sidePanel.shown', function (e) {
            registerSelect(window.sidePanels.getCurrentSidePanel());
            clearInvoiceableInput(window.sidePanels.getCurrentSidePanel())
        })
        .bind('nc.sidePanel.reloaded', function (e) {
            registerSelect(window.sidePanels.getCurrentSidePanel());
        });
}

function clearInvoiceableInput(sidebar) {
    $(document).find('.btn-clear-invoiceable').click(function () {
        $(this).closest('form')[0].reset();
    });
}

function registerSelect(sidebar) {
    sidebar.content.find('tbody tr').click((e) => {
        let row = $(e.target).closest('tr');
        let morph = row.find('td[data-column="morph"] i')

        sidebar.target
            .closest('.input-group')
            .find('input[type="hidden"][name="invoiceable_type"]')
            .val(morph.data('type'))
            .trigger('change');
        sidebar.target
            .closest('.input-group')
            .find('input[type="hidden"][name="invoiceable_id"]')
            .val(morph.data('id'))
            .trigger('change');
        sidebar.target
            .closest('.input-group')
            .find('input[type="text"]')
            .val(morph.data('description').trim())
            .trigger('change');

        /** Check if additional fields should be filled */
        let form = sidebar.target.closest('form');
        let descriptionInput = form.find('input[name="description"]');
        let amountInput = form.find('input[name="amount"]');
        let quantityInput = form.find('input[name="quantity"]');
        let ledgerInput = form.find('select[name="ledger_id"]');
        let vatInput = form.find('select[name="vat_rate_id"]');

        if (descriptionInput.length) {
            descriptionInput.val(morph.data('description'))
        }

        if (amountInput.length) {
            amountInput.val(morph.data('amount'))
        }

        if (quantityInput.length) {
            quantityInput.val(morph.data('quantity'))
        }

        if (ledgerInput.length) {
            ledgerInput.val(morph.data('ledger-id'))
        }

        if (vatInput.length) {
            vatInput.val(morph.data('vat-rate-id'))
        }

        sidebar.close();
    });
}
